export const formatPrice = (input: number | undefined) => {
  if (!input && input !== 0) return null
  return input.toLocaleString('nl-NL', {
    style: 'currency',
    currency: 'EUR',
  })
}
